import { render, staticRenderFns } from "./BannerText.vue?vue&type=template&id=a382008c&scoped=true"
import script from "./BannerText.vue?vue&type=script&lang=js"
export * from "./BannerText.vue?vue&type=script&lang=js"
import style0 from "./BannerText.vue?vue&type=style&index=0&id=a382008c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a382008c",
  null
  
)

export default component.exports